import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_GLACIER } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/blank.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/blank-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/blank-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/blank-extreme.circles.json' with { type: 'json' };

export const BLANK_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'blank',
  baseTitle: "Blank",
  description: "Disfigure's classic NCS melodic dubstep. Snare backbeat, mid-tier wave challenge.",
  difficulty: 3,
  palette: PALETTE_GLACIER,
  audioSrc: '/audio/waves/blank.mp3',
  attribution: "\"Blank\" by Disfigure [NCS Release] - https://ncs.io/Blank",
  mapper: "skildfrix",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 140, offsetMs: 0, totalBeats: 143 },
    hard: { bpm: 140, offsetMs: 0, totalBeats: 143 },
    extreme: { bpm: 140, offsetMs: 0, totalBeats: 143 },
  },
});
